import { Button } from 'blaze-ui/Button'
import Styles from './StrategicRecommendations.module.scss'
import { StickyFooterProvider } from 'providers/StickyFooterProvider/StickyFooterProvider'
import { StickyFooter } from 'components/FirstTimeExperienceModal/components/Footer/Footer'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { FooterButtons } from 'components/FirstTimeExperienceModal/components/Footer/Footer'
import { useBrandKitStrategicRecommendations } from 'hooks/queries/brandKits/useBrandKitStrategicRecommendations'
import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'
import { useState } from 'react'
import { BID_FIELD } from 'screens/blaze/Home/VirtualMarketerHome/StrategicRecommendations/Row'
import { Spinner } from 'common/Spinner/Spinner'
import { Recommendation } from './Recommendation'

export interface StrategicRecommendationsProps {
  onNext: () => void
  onBack: () => void
  brandKitId: number
}

export const StrategicRecommendations = ({ onNext, onBack, brandKitId }: StrategicRecommendationsProps) => {
  const { data: brandKitData, isLoading } = useBrandKit(brandKitId)
  const brandKit = brandKitData?.brand_kit
  const { data: strategicRecommendations, isLoading: isStrategicRecommendationsLoading } =
    useBrandKitStrategicRecommendations({ brandKitId })
  const [showAllRecommendations, setShowAllRecommendations] = useState(false)

  const bidField = BID_FIELD['social']
  const batchId = brandKit?.[bidField]
  const isGenerating = typeof batchId === 'string'

  const topicRecommendations = strategicRecommendations
    ?.filter(({ feature }) => feature === 'topic')
    .slice(0, showAllRecommendations ? undefined : 1)
  const captionRecommendations = strategicRecommendations
    ?.filter(({ feature }) => feature === 'captions')
    .slice(0, showAllRecommendations ? undefined : 1)
  const imageRecommendations = strategicRecommendations
    ?.filter(({ feature }) => feature === 'images')
    .slice(0, showAllRecommendations ? undefined : 1)

  return (
    <MultiStepStepLayout
      scrollContainerClassName={Styles.scrollContainer}
      title="Your personalized content strategy"
      description="Based on your account performance and brand profile"
    >
      <StickyFooterProvider
        footer={
          <StickyFooter>
            <FooterButtons>
              <Button variant="tertiary" size="lg" onPress={onBack} aria-label="Back">
                Back
              </Button>
              <Button size="lg" onPress={onNext} aria-label="Skip for now">
                Start Creating
              </Button>
            </FooterButtons>
          </StickyFooter>
        }
      >
        {strategicRecommendations?.length === 0 && (isLoading || isStrategicRecommendationsLoading) ? (
          <div className={Styles.spinnerContainer}>
            <Spinner />
          </div>
        ) : (
          <>
            <div className={Styles.recommendationsContainer}>
              <Recommendation
                isGenerating={isGenerating}
                recommendations={topicRecommendations}
                title="Content Topics"
                icon="🎯"
              />
              <Recommendation
                isGenerating={isGenerating}
                recommendations={captionRecommendations}
                title="Caption Strategy"
                icon="💬"
              />
              <Recommendation
                isGenerating={isGenerating}
                recommendations={imageRecommendations}
                title="Visual Style"
                icon="🖼️"
              />
            </div>
            {!showAllRecommendations &&
              !isGenerating &&
              strategicRecommendations &&
              strategicRecommendations.length > 0 && (
                <div className={Styles.viewAllRecommendationsContainer}>
                  <Button size="lg" variant="secondary" onPress={() => setShowAllRecommendations(true)}>
                    View All Recommendations
                  </Button>
                </div>
              )}
          </>
        )}
      </StickyFooterProvider>
    </MultiStepStepLayout>
  )
}
